module.exports = __webpack_public_path__ + "media/images/add_attachment-cc32506c94bdce447ac94382cf3812cb.svg";